var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rrj-play-wrapper"},[_c('video',{staticClass:"rrj-txplayer",attrs:{"id":'txplayer' + _vm.video.fileId,"width":"800","height":"450","preload":"auto","playsinline":"","webkit-playsinline":""}}),_c('div',{staticClass:"player-close",on:{"click":_vm.closePlayer}},[_c('i',{staticClass:"el-icon-error"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }